__turbopack_context__.v({
  "actionBtn": "VehicleRestrictionPopup-module-scss-module__-VLgtG__actionBtn",
  "actions": "VehicleRestrictionPopup-module-scss-module__-VLgtG__actions",
  "banner": "VehicleRestrictionPopup-module-scss-module__-VLgtG__banner",
  "bannerWrap": "VehicleRestrictionPopup-module-scss-module__-VLgtG__bannerWrap",
  "body": "VehicleRestrictionPopup-module-scss-module__-VLgtG__body",
  "cancelBtn": "VehicleRestrictionPopup-module-scss-module__-VLgtG__cancelBtn",
  "content": "VehicleRestrictionPopup-module-scss-module__-VLgtG__content",
  "description": "VehicleRestrictionPopup-module-scss-module__-VLgtG__description",
  "primaryBtn": "VehicleRestrictionPopup-module-scss-module__-VLgtG__primaryBtn",
  "title": "VehicleRestrictionPopup-module-scss-module__-VLgtG__title",
});
